import nodeDataFetcher from 'node-data-fetcher';
import DataEngine from './DataEngine';

class NodeDataEngine extends DataEngine {
    constructor (_opts) {
        const opts = {
            ..._opts,
            // don't poll on the server
            poll: false
        };
        super(opts);
    }

    createDataFetcher () {
        this.dataFetcher = nodeDataFetcher(this.opts.dataLoader);
    }

    init (app, _additionalOpts = {}) {
        const additionalOpts = {..._additionalOpts};
        // don't poll on the server, bruh... I told you already.
        additionalOpts.poll = false;
        super.init(app, additionalOpts);
    }
}

export default NodeDataEngine;
